class VideoSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = null;
    this.sliderEl = this.querySelector('.glide');
  }

  connectedCallback() {
    this.slider = new Glide(this.sliderEl, {
      type: 'carousel',
      startAt: 0,
      perView: 4,
      focusAt: 1,
      gap: 16,
      peek: 100,
      breakpoints: {
        749: {
          perView: 1,
          peek: 50,
          gap: 8,
          focusAt: 0,
        }
      }
    }).mount();

    this.slider.on('run.after', this.playVideos.bind(this));
  }

  playVideos () {
    this.querySelectorAll('.glide__slide')
      .forEach(el => {
        const video = el.querySelector('video')
        video.pause();
        video.currentTime = 0;
      });

    const activeVideo = this.querySelector('.glide__slide--active video');

    if (!activeVideo.classList.contains('loaded')) {
      activeVideo.querySelectorAll('source')
        .forEach(source => {
          if (source.src === null || source.src === '') source.src = source.dataset.src;
        });
      activeVideo.load();
      activeVideo.classList.add('loaded');
    }

    activeVideo.play();
  }
}

customElements.define('video-slider', VideoSlider);